import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[egUppercase]',
  standalone: false,
})
export class UppercaseDirective {
  private el = inject(ElementRef);

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const target = event.target as HTMLInputElement;

    // Ensure it's an input/textarea type element
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
      const start = target.selectionStart;
      const end = target.selectionEnd;

      target.value = target.value.toUpperCase();

      // Reset cursor position after case change
      target.setSelectionRange(start, end);
    }
  }
}
